class ProductComparison {
    constructor() {
      this.selectedProducts = new Set();
      this.maxProducts = 4;
      this.init();
      this.loadState();
    }

    init() {
      this.toggleButton = document.querySelector('.filter-toolbar-compare');
      this.compareCountEl = document.querySelector('.filter-toolbar-compare__count');
      this.productGrid = document.querySelector('.product-grid');
      this.stickyBar = document.querySelector('.comparison-sticky-bar');
      this.productsContainer = document.querySelector('.comparison-products');
      this.compareButton = document.querySelector('.compare-button');
      this.modal = document.querySelector('.comparison-modal');
      this.modalClose = document.querySelector('.comparison-modal-close');
      this.comparisonTable = document.querySelector('.comparison-table');
      
      this.bindEvents();
      this.updateCompareCount();
    }

    bindEvents() {
      if (this.toggleButton) {
        this.toggleButton.addEventListener('click', () => this.toggleComparisonMode());
      }
      
      document.querySelectorAll('.product-comparison-checkbox').forEach(checkbox => {
        checkbox.addEventListener('change', (e) => this.handleProductSelection(e));
      });

      if (this.compareButton) {
        this.compareButton.addEventListener('click', () => this.showComparison());
      }

      if (this.modalClose) {
        this.modalClose.addEventListener('click', () => this.hideComparison());
      }
      
      if (this.modal) {
        this.modal.addEventListener('click', (e) => {
          if (e.target === this.modal) {
            this.hideComparison();
          }
        });
      }

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          this.saveState();
        }
      });

      window.addEventListener('beforeunload', () => {
        this.saveState();
      });
    }

    updateCompareCount() {
      const count = this.selectedProducts.size;
      if (this.compareCountEl) {
        this.compareCountEl.textContent = String(count);
      }
    }

    saveState() {
      if (!this.productGrid) return;

      const state = {
        isComparing: this.productGrid.classList.contains('comparison-mode'),
        selectedProducts: Array.from(this.selectedProducts)
      };
      sessionStorage.setItem('productComparisonState', JSON.stringify(state));
    }

    loadState() {
      if (!this.productGrid) return;

      const autoEnableRoot = document.querySelector('.product-comparison-root');
      const shouldAutoEnable = autoEnableRoot?.dataset.autoEnableComparison === 'true';

      try {
        const savedState = sessionStorage.getItem('productComparisonState');
        if (savedState) {
          const state = JSON.parse(savedState);
          
          if (state.isComparing) {
            this.toggleComparisonMode();
          }

          state.selectedProducts.forEach(productId => {
            const checkbox = document.querySelector(`.product-comparison-checkbox[data-product-id="${productId}"]`);
            if (checkbox) {
              checkbox.checked = true;
              this.selectedProducts.add(productId);
              this.addToComparisonBar(checkbox.dataset);
            }
          });

          this.updateStickyBarVisibility();
          this.updateCompareCount();
        } else if (shouldAutoEnable && !this.productGrid.classList.contains('comparison-mode')) {
          this.toggleComparisonMode();
        }
      } catch (error) {
        console.error('Error loading comparison state:', error);
        this.clearComparison();
        if (shouldAutoEnable && !this.productGrid.classList.contains('comparison-mode')) {
          this.toggleComparisonMode();
        }
      }
    }

    toggleComparisonMode() {
      if (!this.productGrid || !this.toggleButton) return;

      this.productGrid.classList.toggle('comparison-mode');
      const isActive = this.productGrid.classList.contains('comparison-mode');
      this.toggleButton.classList.toggle('is-active', isActive);
      this.toggleButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      
      if (!isActive) {
        this.clearComparison();
      }

      this.saveState();
    }

    handleProductSelection(event) {
      const checkbox = event.target;
      const productId = checkbox.dataset.productId;
      
      if (checkbox.checked) {
        if (this.selectedProducts.size >= this.maxProducts) {
          checkbox.checked = false;
          alert('You can compare up to 4 products at a time');
          return;
        }
        this.selectedProducts.add(productId);
        this.addToComparisonBar(checkbox.dataset);
      } else {
        this.selectedProducts.delete(productId);
        this.removeFromComparisonBar(productId);
      }
      
      this.updateStickyBarVisibility();
      this.updateCompareCount();
      this.saveState();
    }

    addToComparisonBar(productData) {
      if (!this.productsContainer) return;

      const productElement = document.createElement('div');
      productElement.className = 'comparison-product';
      productElement.dataset.productId = productData.productId;
      
      productElement.innerHTML = `
        <img src="${productData.productImage}" alt="${productData.productTitle}">
        <button type="button" class="remove" onclick="productComparison.removeProduct('${productData.productId}')">&times;</button>
        <div class="product-title">${productData.productTitle}</div>
      `;
      
      this.productsContainer.appendChild(productElement);
    }

    removeProduct(productId) {
      this.selectedProducts.delete(productId);
      const checkbox = document.querySelector(`.product-comparison-checkbox[data-product-id="${productId}"]`);
      if (checkbox) checkbox.checked = false;
      this.removeFromComparisonBar(productId);
      this.updateStickyBarVisibility();
      this.updateCompareCount();
      this.saveState();
    }

    removeFromComparisonBar(productId) {
      if (!this.productsContainer) return;

      const productElement = this.productsContainer.querySelector(`[data-product-id="${productId}"]`);
      if (productElement) productElement.remove();
    }

    updateStickyBarVisibility() {
      if (!this.stickyBar) return;

      this.stickyBar.classList.toggle('active', this.selectedProducts.size > 0);
    }

    clearComparison() {
      this.selectedProducts.clear();
      if (this.productsContainer) {
        this.productsContainer.innerHTML = '';
      }
      document.querySelectorAll('.product-comparison-checkbox').forEach(checkbox => {
        checkbox.checked = false;
      });
      this.updateStickyBarVisibility();
      this.updateCompareCount();
      this.hideComparison();
      this.saveState();
    }

    showComparison() {
      if (!this.modal) return;

      if (this.selectedProducts.size < 2) {
        alert('Please select at least 2 products to compare');
        return;
      }

      const tableHeader = this.modal.querySelector('.comparison-details-table thead tr');
      const tableRows = this.modal.querySelectorAll('.comparison-details-table tbody tr');
      
      tableHeader.querySelectorAll('th:not(.feature-label)').forEach(th => th.remove());
      tableRows.forEach(row => {
        row.querySelectorAll('td').forEach(td => td.remove());
      });

      document.querySelectorAll('.product-comparison-checkbox:checked').forEach(checkbox => {
        const data = checkbox.dataset;
        
        const headerCell = document.createElement('th');
        headerCell.dataset.productId = data.productId;
        headerCell.textContent = data.productTitle;
        tableHeader.appendChild(headerCell);

        const imageCell = document.createElement('td');
        imageCell.dataset.productId = data.productId;
        imageCell.innerHTML = `
          <div class="product-image-cell">
            <button type="button" class="remove-product" onclick="productComparison.removeFromComparison('${data.productId}')">&times;</button>
            <img src="${data.productImage}" alt="${data.productTitle}">
            <div class="product-title">${data.productTitle}</div>
            <a href="${data.productUrl}" class="view-details button button-primary">View Details</a>
          </div>
        `;
        tableRows[0].appendChild(imageCell);

        const descriptionCell = document.createElement('td');
        descriptionCell.dataset.productId = data.productId;
        descriptionCell.textContent = data.productDescription || 'No description available';
        tableRows[1].appendChild(descriptionCell);

        const priceCell = document.createElement('td');
        priceCell.dataset.productId = data.productId;
        priceCell.textContent = data.productPrice;
        tableRows[2].appendChild(priceCell);

        const vendorCell = document.createElement('td');
        vendorCell.dataset.productId = data.productId;
        vendorCell.textContent = data.productVendor;
        tableRows[3].appendChild(vendorCell);

        const typeCell = document.createElement('td');
        typeCell.dataset.productId = data.productId;
        typeCell.textContent = data.productType || 'N/A';
        tableRows[4].appendChild(typeCell);

        const dimensionsCell = document.createElement('td');
        dimensionsCell.dataset.productId = data.productId;
        const dimensionsText = (data.productDimensions || '').trim();
        dimensionsCell.textContent = dimensionsText || 'N/A';
        dimensionsCell.style.color = dimensionsText ? 'inherit' : '#666';
        tableRows[5].appendChild(dimensionsCell);
      });

      this.modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    removeFromComparison(productId) {
      this.selectedProducts.delete(productId);
      
      const checkbox = document.querySelector(`.product-comparison-checkbox[data-product-id="${productId}"]`);
      if (checkbox) checkbox.checked = false;

      this.removeFromComparisonBar(productId);

      const headerCell = this.modal.querySelector(`.comparison-details-table th[data-product-id="${productId}"]`);
      if (headerCell) headerCell.remove();

      this.modal.querySelectorAll(`.comparison-details-table td[data-product-id="${productId}"]`).forEach(cell => {
        cell.remove();
      });

      this.updateStickyBarVisibility();
      this.updateCompareCount();
      this.saveState();

      if (this.selectedProducts.size < 2) {
        this.hideComparison();
      }
    }

    hideComparison() {
      if (!this.modal) return;

      this.modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  const productComparison = new ProductComparison();
